import { render, staticRenderFns } from "./AppSubMenu.vue?vue&type=template&id=5e00123e"
import script from "./AppSubMenu.vue?vue&type=script&lang=ts"
export * from "./AppSubMenu.vue?vue&type=script&lang=ts"
import style0 from "./AppSubMenu.vue?vue&type=style&index=0&id=5e00123e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports